"use client";

import { ArrowRight, Timer } from "@/components/Svg";
import CPaginationWithLinksSkeleton from "@/components/main/CPaginationWithLinksSkeleton";
import { Card, Container, Grid, Skeleton } from "@mantine/core";
import Link from "next/link";

const loading = () => {
  return (
    <Container className="my-10">
      <Grid>
        {Array.from(Array(12))?.map((blogPost, index) => (
          <Grid.Col sm={12} md={6} lg={4} key={index}>
            <Card padding="lg" radius="md" withBorder className="max-w-[400px]">
              <Card.Section className="relative">
                <Skeleton
                  height={250}
                  width={400}
                  className=" object-cover object-center"
                />
              </Card.Section>
              <Skeleton height={28} width={200} className="m-0 mt-3" />

              <div className="my-2 flex items-center text-primary">
                <Skeleton height={25} width={100} className="m-0 " />
              </div>
              <Skeleton height={62} width={300} className="mb-1 " />

              <div className="mt-3 flex items-center text-primary">
                <Skeleton height={25} width={100} className="m-0 mt-3" />
              </div>
            </Card>
          </Grid.Col>
        ))}
      </Grid>
      <CPaginationWithLinksSkeleton />
    </Container>
  );
};

export default loading;
